import { cn } from '../../lib/utils';
import { Sparkles } from 'lucide-react';

type MentalModel = {
  name: string;
  summary: string;
  how_to_apply: string;
};

type MentalModelsProps = {
  title: string;
  data: MentalModel[];
  className?: string;
};

export default function MentalModels({ title, data, className }: MentalModelsProps) {
  if (!data?.length) {
    return null;
  }

  return (
    <section className={cn('rounded-2xl border border-slate-200 bg-white p-6 shadow-sm dark:border-slate-800 dark:bg-slate-900/70', className)}>
      <header className="mb-4 flex items-center gap-3">
        <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-indigo-600 text-indigo-50 shadow">
          <Sparkles className="h-5 w-5" />
        </span>
        <div>
          <h3 className="text-lg font-semibold text-slate-900 dark:text-slate-100">{title}</h3>
          <p className="text-sm text-slate-600 dark:text-slate-300">
            Anchor your next sprint in proven lenses. Re-read before big decisions to stay aligned with your growth narrative.
          </p>
        </div>
      </header>

      <div className="grid gap-4 md:grid-cols-2">
        {data.slice(0, 2).map((model) => (
          <article
            key={model.name}
            className="flex h-full flex-col justify-between rounded-xl border border-indigo-100 bg-indigo-50/60 p-5 shadow-sm transition hover:border-indigo-300 dark:border-indigo-900/50 dark:bg-indigo-950/40"
          >
            <div className="space-y-3">
              <h4 className="text-base font-semibold text-indigo-900 dark:text-indigo-200">{model.name}</h4>
              <p className="text-sm text-indigo-900/80 dark:text-indigo-100/80">{model.summary}</p>
            </div>
            <div className="mt-4 rounded-lg border border-indigo-200 bg-white/70 p-4 text-sm text-slate-700 dark:border-indigo-800 dark:bg-slate-950/40 dark:text-slate-200">
              <p className="font-semibold text-indigo-900 dark:text-indigo-200">How to apply now</p>
              <p className="mt-1 leading-relaxed">{model.how_to_apply}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
